/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Contract = {

	delete (context, contractTemplateId, onSuccess, onError, options) {
		Api.delete(context,
			"/contract"
			+ "?contractTemplateId=" + contractTemplateId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, departmentId, onSuccess, onError, options) {
		Api.get(context,
			"/contract"
			+ "?departmentId=" + departmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDownload (context, contractTemplateId, onSuccess, onError, options) {
		Api.get(context,
			"/contract/download"
			+ "?contractTemplateId=" + contractTemplateId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getGenerate (context, projectId, templateId, onSuccess, onError, options) {
		Api.get(context,
			"/contract/generate"
			+ "?projectId=" + projectId
			+ "&templateId=" + templateId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, file, departmentId, onSuccess, onError, options) {
		Api.post(context,
			"/contract"
			+ "?file=" + file
			+ "&departmentId=" + departmentId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
